import api from '@/api';
import { FileListItem } from "@/components/IBFile/interface";
import {
	ForexAccountVerifying,
	ForexBuyContract,
	ForexBuyDeletedFile,
	ForexBuyDraft,
	ForexBuyIdnSearchParams,
	ForexBuyUploadedFile,
	ForexCountrySearchParams,
	ForexCountrySearchResult,
} from "@/feature/Forex/api/form/forex-form.interface";
import { CancelableApiResponse, IApiHandlerParams } from "@/api/interface";
import {
	mapForexAccountVerifying,
	mapForexBuyCreatedDraft
} from "@/feature/Forex/api/form/forex-form.utils";
import ObjectUtils from "@/modules/Object/ObjectUtils";
import { $uploadFileAndTrackProgress } from '@/api/files/files';
import { cacheListRequest } from '@/api/cache/cache';

export const $createForexDraft = async (
	draft?: ForexBuyDraft
): Promise<Required<ForexBuyDraft>> => {
	// return require('./__mock__/create-draft-buy.mock.json').data;

	return api
		.post('foreign-exchange/draft', draft)
		.then(mapForexBuyCreatedDraft);
};

export const $updateForexDraft = async (
	draft: ForexBuyDraft
): Promise<Required<ForexBuyDraft>> => {
	// return require('./__mock__/create-draft-buy.mock.json').data;

	return api
		.patch('foreign-exchange/draft', draft);
};

export const $deleteForexFile = async (
	docId: string
): Promise<ForexBuyDeletedFile | null> => {
	// return require('./__mock__/delete-file-buy.mock.json').data;

	return api
		.delete('foreign-exchange/delete-file/' + docId);
};

export const $uploadForexFile = (
	payload: FormData,
	fileItem: FileListItem
): CancelableApiResponse<ForexBuyUploadedFile | null> => {
	return $uploadFileAndTrackProgress(
		'foreign-exchange/upload-file',
		payload,
		fileItem
	);
};

export const $sendForexDraftToAccountant = (
	draft?: ForexBuyDraft
): Promise<ForexBuyDraft> => api
	.post('foreign-exchange/send-to-accountant', draft);

export const $sendForexDraftToDirector = (
	draft?: ForexBuyDraft
): Promise<ForexBuyDraft> => api
	.post('foreign-exchange/send-to-director', draft);

export const $getForexContracts = async (
	_params?: ForexBuyIdnSearchParams
): Promise<ForexBuyContract[]> => {
	// return require('./__mock__/cbs-contract-list.json').data;

	return api
		.get('foreign-exchange/cbs/contract-list', {
			handler: { disableLoader: true },
			// request: { params }
		})
		.then(response => response || []);
};

export const $getCachedForexContracts = cacheListRequest(
	$getForexContracts,
	[ 'idn' ],
	'idn'
);

export const $canSendForexDraftToBank = (
	draft?: ForexBuyDraft
): Promise<Required<ForexAccountVerifying>> => api
	.post('foreign-exchange/account-verification', draft)
	// .then(() => ObjectUtils.deepCopy(ObjectUtils.deepCopy(
	// 	require('../__mock__/can-send-forex-draft-to-bank.json').data
	// )))
	.then(mapForexAccountVerifying);

export const $getForexCountries = async (
	body: ForexCountrySearchParams,
	handler?: IApiHandlerParams
): Promise<ForexCountrySearchResult[]> => {
	// return ObjectUtils.deepCopy(
	// 	require('../__mock__/get-countries.json').data
	// );

	return api
		.post('reference-information/get-countries', body, {
			handler
		})
		.then(response => response || []);
};